import { Typography } from "@mui/joy";
import React, { useEffect, useState } from "react";
import useApiService from "../../../hooks/useApiService";
import { ClientRecord } from "../../../models/ClientInfo";
import { RouteComponentProps } from "../../../models/RouteComponent";
import { Card } from "primereact/card";
import { Input } from "../../../components/Shared/Forms";
import styles from "../client.module.css";
import { PhoneInput } from "react-international-phone";
import { Button } from "primereact/button";
import ButtonPanel from "../../../components/Shared/ButtonPanel";
import { useToast } from "../../../context/ToastContext";

function ContactDetails(props: RouteComponentProps) {
  const { session } = props;
  const toast = useToast();

  const [clientDetails, setClientDetails] = useState<ClientRecord>();
  const [formData, setFormData] = useState<Partial<ClientRecord>>({
    contact_person: "",
    mobile: "",
    email: "",
  });
  const [somethingChanged, setSomethingChanged] = useState<boolean>(false);

  console.log("seomething changes", somethingChanged);

  const { loading: loadingClient, invalidate } = useApiService<ClientRecord>({
    url: `client/${session.client_id}`,
    method: "GET",
    apiName: "core",
    onSuccess: data => {
      setClientDetails(data);
      setFormData(prev => ({
        ...prev,
        email: data.email,
        contact_person: data.contact_person,
        mobile: data.mobile,
      }));
    },
    cache: { enabled: true, strategy: "cache-first", ttlMs: 5 * 60_000 },
  });

  const { loading: updatingClient, fetchData: updateClient } = useApiService<ClientRecord>({
    fetchOnMount: false,
    url: `client/${session.client_id}`,
    method: "PUT",
    apiName: "core",
    onSuccess: data => {
      setSomethingChanged(false);
      setClientDetails(prev => ({
        ...prev,
        ...data,
      }));
      invalidate();
      toast("success", "Client record successfully updated");
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loadingClient);
  }, [loadingClient]);

  async function handleSave() {
    let formValues: any = {
      ...formData,
    };

    let updateObject = {
      ...clientDetails,
      ...formValues,
    };

    delete updateObject.consultant_name;
    delete updateObject.industry_list;
    delete updateObject.updated_at;
    delete updateObject.created_at;
    delete updateObject.photo;
    delete updateObject.deleted_at;

    await updateClient({
      payload: updateObject,
    });
  }

  function handleCancel() {
    if (clientDetails) {
      setSomethingChanged(false);
      setFormData(prev => ({
        ...prev,
        mobile: clientDetails?.mobile,
        contact_person: clientDetails?.contact_person,
        email: clientDetails?.email,
      }));
    }
  }

  return (
    <>
      <Typography level="h2" component="h1">
        Contact Details
      </Typography>
      <Card>
        <div className={styles["responsive-grid-2"]}>
          <Input
            label={"Contact name"}
            value={formData.contact_person}
            name={"contact_person"}
            placeholder={"eg. John Doe"}
            onChange={e => {
              setSomethingChanged(true);
              setFormData(prev => ({
                ...prev,
                contact_person: e.target.value,
              }));
            }}
          />
          <div>
            <label className="block mb-2">Phone number</label>
            <PhoneInput
              defaultCountry="za"
              value={formData.mobile}
              name={"client_agent_phone"}
              onChange={e => {
                setSomethingChanged(true);
                setFormData({
                  ...formData,
                  mobile: e || "",
                });
              }}
              inputStyle={{
                width: "100%",
                height: "50px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                padding: "0.75rem",
                fontSize: "1rem",
                lineHeight: "1.5",
                backgroundColor: "#ffffff",
                outline: "none",
                transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
              }}
              countrySelectorStyleProps={{
                buttonStyle: {
                  border: "1px solid #d1d5db",
                  borderRadius: "6px 0 0 6px",
                  backgroundColor: "#ffffff",
                  padding: "0.75rem 0.5rem",
                  height: "50px",
                },
              }}
              inputClassName="p-inputtext"
            />
          </div>
          <Input
            label={"Email"}
            value={formData.email}
            name={"email"}
            placeholder={"eg. john.doe@dsf.co.za"}
            onChange={e => {
              setSomethingChanged(true);
              setFormData(prev => ({
                ...prev,
                email: e.target.value,
              }));
            }}
          />
        </div>
      </Card>
      <ButtonPanel inModal={false}>
        <Button
          label={"Cancel"}
          outlined={true}
          disabled={!somethingChanged || updatingClient}
          onClick={handleCancel}
        />
        <Button
          label={"Save"}
          loading={updatingClient}
          disabled={!somethingChanged}
          onClick={async () => {
            await handleSave();
          }}
        />
      </ButtonPanel>
    </>
  );
}

export default ContactDetails;
